import React, { Component } from 'react';
import ComponentIcon from '@material-ui/icons/Save';

class SaveIcon extends Component {
  render() {
    return <ComponentIcon {...this.props} />;
  }
}

export default SaveIcon;
